export type BuildInfo = typeof __BUILD_INFO__

export const BUILD_INFO: BuildInfo = __BUILD_INFO__

export const registerBuildInfo = () => {
  window.__JUSTLOCKIT_BUILD__ = BUILD_INFO
}
